import { render, staticRenderFns } from "./BlockSlideFormCarousel.vue?vue&type=template&id=235950bc"
import script from "./BlockSlideFormCarousel.vue?vue&type=script&lang=js"
export * from "./BlockSlideFormCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.1__lodash@4_50f6069bc14464b8bd79aa1c8f71d64f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports